import { memo } from "react";

const QualityIcon = () => (
	<svg
		viewBox="0 0 48 48"
		width="45"
		height="45"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.5"
		aria-hidden="true"
	>
		<circle cx="24" cy="24" r="19" />
		<path d="m15 24 6 6 12-13" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const OfferIcon = () => (
	<svg
		viewBox="0 0 48 48"
		width="45"
		height="45"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.3"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M16 14c0-5 4-8 8-8s8 3 8 8" />
		<path d="M11 17h26l-3 24H14z" />
		<path d="M20 23h8M20 29h8M24 20v12" />
	</svg>
);

function Shapingd() {
	return (
		<section className="perf-defer-section my-10 grid grid-cols-1 gap-8 overflow-x-hidden px-6 md:grid-cols-2 md:gap-10 md:px-16">
			<div className="text-center">
				<div className="my-4 flex items-center justify-center">
					<QualityIcon />
				</div>
				<h2 className="my-1 font-Jost-Medium text-2xl">Top Quality</h2>
				<p className="font-Jost-Regular text-gray-600">
					Wrap Yourself in Luxury - Our Commitment to the Best Quality Fabric.
				</p>
			</div>

			<div className="text-center">
				<div className="my-4 flex items-center justify-center">
					<OfferIcon />
				</div>
				<h2 className="my-1 font-Jost-Medium text-2xl">Best Offers</h2>
				<p className="font-Jost-Regular text-gray-600">
					Discover Our Best Price Offers Today!
				</p>
			</div>
		</section>
	);
}

export default memo(Shapingd);
